import { SORT_TYPES } from '../constants/sort';

export const getTemplatesLibraryRequestQueryParams = (parsedSearchParams) => {
    const queryParams = { ordering: parsedSearchParams.sort || SORT_TYPES.created };
    if (parsedSearchParams.search) {
        queryParams.search = parsedSearchParams.search;
    }
    return queryParams;
};
